var exports = {
  "--light-text-primary": "#152242",
  "--light-control-primary-basic": "#0468ff",
};

module.exports = exports;
